(() => {
  const page = document.querySelector('.sfg-a1');
  const header = document.querySelector('.page-header');
  if (!page) return;
  let frame;
  function measure() {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      const height = header ? Math.ceil(header.getBoundingClientRect().height) : 0;
      if (page.style.getPropertyValue('--sfg-header-height') !== height + 'px') {
        page.style.setProperty('--sfg-header-height', height + 'px');
        document.dispatchEvent(new Event('sfg:geometry'));
      }
    });
  }
  if (header && 'ResizeObserver' in window) new ResizeObserver(measure).observe(header);
  window.addEventListener('resize', measure, { passive: true });
  document.addEventListener('shopify:section:load', measure);
  measure();
})();

(() => {
  const rows = new Map();
  const calm = matchMedia('(prefers-reduced-motion: reduce)');
  let observer, frame;
  function complete(row, state) {
    state.done = true;
    row.classList.add('gs-armed', 'gs-tl-static');
    row.classList.remove('gs-tl-running');
    observer?.unobserve(row);
  }
  function rebuild() {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      observer?.disconnect();
      rows.forEach((state, row) => { if (!row.isConnected) rows.delete(row); });
      if (calm.matches || window.Shopify?.designMode || !('IntersectionObserver' in window)) {
        rows.forEach((state, row) => complete(row, state));
        return;
      }
      const header = document.querySelector('.page-header');
      const top = header ? Math.ceil(header.getBoundingClientRect().height) : 0;
      const bar = document.querySelector('.sfg-a1 .stickyCta');
      const rect = bar?.getBoundingClientRect();
      const barHeight = rect && rect.top < innerHeight && getComputedStyle(bar).display !== 'none' ? Math.ceil(rect.height) : 0;
      const bottom = Math.max(barHeight, Math.round(innerHeight * .15));
      observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          const state = rows.get(entry.target);
          if (!state || state.done) return;
          const visibleHeight = Math.min(entry.boundingClientRect.height, entry.rootBounds?.height || innerHeight);
          if (!state.started && entry.isIntersecting && entry.intersectionRect.height >= visibleHeight * .8) {
            state.started = true;
            entry.target.classList.add('gs-play');
          }
          entry.target.classList.toggle('gs-tl-running', state.started && entry.isIntersecting);
        });
      }, { threshold: [0, .25, .5, .8, 1], rootMargin: `-${top}px 0px -${bottom}px 0px` });
      rows.forEach((state, row) => { if (!state.done) observer.observe(row); });
    });
  }
  const sizes = 'ResizeObserver' in window ? new ResizeObserver(rebuild) : null;
  function init(root = document) {
    root.querySelectorAll('[data-anim="timeline"]').forEach(row => {
      if (rows.has(row)) return;
      const state = { started: false, done: false };
      rows.set(row, state);
      row.classList.add('gs-armed');
      sizes?.observe(row);
      row.querySelector('[data-tl-fill]')?.addEventListener('animationend', event => {
        if (event.animationName === 'gs-tl-run') complete(row, state);
      });
    });
    rebuild();
  }
  window.addEventListener('resize', rebuild, { passive: true });
  document.addEventListener('sfg:geometry', rebuild);
  document.addEventListener('shopify:section:load', event => init(event.target));
  calm.addEventListener('change', rebuild);
  document.fonts?.ready.then(rebuild);
  init();
})();

if (!window.Shopify || !window.Shopify.designMode) {

/* Hide the sticky mobile button while the hero button or a plan selector is on screen. */
(function(){
  var bar=document.querySelector('.stickyCta'), sel=['.hCta','#offer','#offer2'], seen=new Map();
  if(!bar||!('IntersectionObserver' in window)) return;
  var io=new IntersectionObserver(function(es){
    es.forEach(function(e){ seen.set(e.target, e.isIntersecting); });
    var any=false; seen.forEach(function(v){ if(v) any=true; });
    bar.classList.toggle('off', any);
  },{threshold:0.05});
  sel.forEach(function(q){ var el=document.querySelector(q); if(el) io.observe(el); });
})();


(() => {
  if (!('IntersectionObserver' in window)) return;
  const page = document.querySelector('.sfg-a1');
  const calm = matchMedia('(prefers-reduced-motion: reduce)');
  const pending = new Set();
  let observer, frame;
  function finish(el) {
    el.classList.add('gs-play');
    const delay = Number(el.dataset.gsDone);
    if (delay > 0) setTimeout(() => el.classList.add('gs-done'), Math.min(delay, 900));
    pending.delete(el);
    observer?.unobserve(el);
  }
  function rebuild() {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      observer?.disconnect();
      if (calm.matches) { pending.forEach(finish); return; }
      const header = document.querySelector('.page-header');
      const headerHeight = header ? Math.ceil(header.getBoundingClientRect().height) : 0;
      const bar = page?.querySelector('.stickyCta');
      const barRect = bar?.getBoundingClientRect();
      const barHeight = barRect && barRect.top < innerHeight && getComputedStyle(bar).display !== 'none' ? Math.ceil(barRect.height) : 0;
      const bottom = Math.max(barHeight, Math.round(innerHeight * .15));
      observer = new IntersectionObserver(entries => {
        entries.forEach(entry => { if (entry.isIntersecting) finish(entry.target); });
      }, { threshold: 0, rootMargin: `-${headerHeight}px 0px -${bottom}px 0px` });
      pending.forEach(el => observer.observe(el));
    });
  }
  function init(root = document) {
    root.querySelectorAll('[data-gs-onview]:not([data-anim="timeline"])').forEach(el => {
      if (el.dataset.gsReady) return;
      el.dataset.gsReady = '1';
      if (calm.matches) { finish(el); return; }
      el.classList.add('gs-armed');
      pending.add(el);
      if ('ResizeObserver' in window) sizes.observe(el);
    });
    rebuild();
  }
  const sizes = 'ResizeObserver' in window ? new ResizeObserver(rebuild) : null;
  window.addEventListener('resize', rebuild, { passive: true });
  window.addEventListener('orientationchange', rebuild);
  document.addEventListener('sfg:geometry', rebuild);
  document.addEventListener('shopify:section:load', event => init(event.target));
  calm.addEventListener('change', rebuild);
  if (document.fonts?.ready) document.fonts.ready.then(rebuild);
  init();
})();


/* TRACK BALL (only in the -animated file). Section 9, month by month.
   A ball rides the line between the numbered circles and follows the scroll in both directions.
   It sits level with a reading line, but never before the first circle or past the last one. The reading line is 55% down the screen
   on desktop and 45% down on phones (REF_WIDE and REF_PHONE below): on a phone the eye rests higher, between 25% and 50% of the screen height
   (see Knowledge/viewport_gaze_hot_zones_by_device.svg), and the sticky button bar covers the bottom of the screen.
   Where the line is broken (between the two phases) it hides at the end of the line and waits under the next circle.
   The line fills behind it, reached circles get a ring, and arriving at the last circle sets off the sparks
   (again only after the ball has gone back above the circle before it).
   Desktop and phones; not for visitors with reduced motion. Without this script the list is simply still.
   It stands alone and runs again when Shopify's theme editor reloads a section. */
(function(){
  if(!window.requestAnimationFrame||!window.matchMedia) return;
  var wide=window.matchMedia('(min-width:861px)'), calm=window.matchMedia('(prefers-reduced-motion: reduce)');
  var REF_WIDE=0.55, REF_PHONE=0.45;
  var tracks=[], queued=false;
  function setup(root){
    var found=(root&&root.querySelectorAll?root:document).querySelectorAll('[data-anim="track"]');
    Array.prototype.forEach.call(found,function(el){
      if(el.getAttribute('data-gs-ready')) return;
      var ball=el.querySelector('[data-track-ball]'), dots=el.querySelectorAll('[data-track-dot]');
      if(!ball||dots.length<2) return;
      el.setAttribute('data-gs-ready','1');
      tracks.push({el:el,ball:ball,dots:dots,burst:el.querySelector('[data-track-burst]'),lastY:null,done:false});
    });
    ask();
  }
  function lineOf(dot){ var rail=dot.parentNode; return rail?rail.querySelector('[data-track-line]'):null; }
  function update(){
    queued=false;
    var on=!calm.matches, vh=window.innerHeight, ref=vh*(wide.matches?REF_WIDE:REF_PHONE);
    tracks.forEach(function(t){
      if(!document.body.contains(t.el)) return;
      t.el.classList.toggle('gs-track-on',on);
      if(!on) return;
      var box=t.el.getBoundingClientRect();
      if(box.bottom<-300||box.top>vh+300) return;
      var c=[], i, n=t.dots.length, r;
      for(i=0;i<n;i++){ r=t.dots[i].getBoundingClientRect(); c.push({y:r.top+r.height/2,x:r.left+r.width/2}); }
      var k=-1; for(i=0;i<n;i++){ if(c[i].y<=ref) k=i; }
      var y, hide=false;
      if(k<0){ y=c[0].y; }
      else if(k===n-1){ y=c[n-1].y; }
      else{
        var ln=lineOf(t.dots[k]), end=ln?ln.getBoundingClientRect().bottom:c[k].y;
        if(c[k+1].y-end<=30){ y=ref; }            /* the line runs straight on to the next circle */
        else if(ref<end){ y=ref; }                /* still on the line before a break */
        else{ y=c[k+1].y; hide=true; }            /* in the break: wait under the next circle */
      }
      /* ball */
      if(t.lastY!==null&&Math.abs((y-box.top)-t.lastY)>80) t.ball.classList.add('gs-jump'); else t.ball.classList.remove('gs-jump');
      t.lastY=y-box.top;
      t.ball.style.transform='translate('+(c[0].x-box.left).toFixed(1)+'px,'+(y-box.top).toFixed(1)+'px)';
      t.ball.classList.toggle('gs-hide',hide);
      /* lines and circles */
      for(i=0;i<n;i++){
        t.dots[i].classList.toggle('gs-on',c[i].y<=y+0.5&&k>=0);
        var l=lineOf(t.dots[i]);
        if(l){ var lr=l.getBoundingClientRect(), f=lr.height>0?(y-lr.top)/lr.height:0; l.style.setProperty('--gs-fill',Math.max(0,Math.min(1,f)).toFixed(3)); }
      }
      /* sparks at the last circle */
      var atEnd=(k===n-1);
      if(atEnd&&!t.done){
        t.done=true;
        if(t.burst){ t.burst.classList.remove('gs-go'); void t.burst.offsetWidth; t.burst.classList.add('gs-go'); }
        var last=t.dots[n-1]; last.classList.remove('gs-pop'); void last.offsetWidth; last.classList.add('gs-pop');
      }
      if(t.done&&k<n-2) t.done=false;
    });
  }
  function ask(){ if(!queued){ queued=true; requestAnimationFrame(update); } }
  window.addEventListener('scroll',ask,{passive:true});
  window.addEventListener('resize',ask);
  window.addEventListener('load',ask);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ setup(); }); else setup();
  document.addEventListener('shopify:section:load',function(e){ setup(e.target); });
})();


/* VIDEO STRIP (only in the -animated file). Section 10.
   Turns the row of video tiles into an endless strip that moves right to left.
   It copies the tiles as many times as the screen width needs, then once more, so the loop has no seam.
   Speed stays the same however many tiles there are: 7 seconds per tile.
   The strip only moves while it is on screen (even partly). Desktop and phones; not for visitors with reduced motion.
   On phones it also sets where the loop starts (--gs-mq-delay), so that the first tile stands PHONE_INSET pixels in from the left edge, in line with the text.
   Without this script the tiles are a row you can scroll sideways.
   It stands alone and runs again when Shopify's theme editor reloads a section. */
(function(){
  if(!window.matchMedia) return;
  var wide=window.matchMedia('(min-width:861px)'), calm=window.matchMedia('(prefers-reduced-motion: reduce)');
  var SECONDS_PER_TILE=7, PHONE_INSET=24, strips=[], timer=null;
  function build(st){
    var track=st.track, mq=st.el;
    Array.prototype.slice.call(track.querySelectorAll('[data-mq-clone]')).forEach(function(c){ track.removeChild(c); });
    var on=!calm.matches;
    mq.classList.toggle('gs-mq-on',on);
    st.reps=0; st.wide=wide.matches;
    if(!on) return;
    var items=Array.prototype.slice.call(track.children); if(!items.length) return;
    var setW=track.scrollWidth; if(!setW) return;
    var reps=Math.max(1,Math.ceil((mq.clientWidth+60)/setW)), copies=reps*2-1, k;
    for(k=0;k<copies;k++){
      items.forEach(function(it){ var c=it.cloneNode(true); c.setAttribute('data-mq-clone',''); c.setAttribute('aria-hidden','true'); c.inert=true; c.removeAttribute('data-shopify-editor-block'); c.querySelectorAll('[data-shopify-editor-block],[id]').forEach(function(n){n.removeAttribute('data-shopify-editor-block');n.removeAttribute('id');}); track.appendChild(c); });
    }
    var dur=items.length*reps*SECONDS_PER_TILE;
    track.style.setProperty('--gs-mq-dur',dur+'s');
    /* phones: start the loop just before its end, where the first tile is PHONE_INSET in from the left and the last tile is leaving on the left */
    track.style.setProperty('--gs-mq-delay',wide.matches?'0s':(-dur*(1-PHONE_INSET/(setW*reps))).toFixed(2)+'s');
    st.reps=reps; st.w=mq.clientWidth;
  }
  function setup(root){
    var found=(root&&root.querySelectorAll?root:document).querySelectorAll('[data-anim="marquee"]');
    Array.prototype.forEach.call(found,function(el){
      if(el.getAttribute('data-gs-ready')) return;
      var track=el.querySelector('[data-mq-track]'); if(!track) return;
      el.setAttribute('data-gs-ready','1');
      var st={el:el,track:track,reps:0,w:0,wide:null}; strips.push(st); build(st);
      if('IntersectionObserver' in window){
        new IntersectionObserver(function(es){ es.forEach(function(e){ el.classList.toggle('gs-run',e.isIntersecting); }); },{threshold:0}).observe(el);
      } else el.classList.add('gs-run');
    });
  }
  function rebuild(){ strips.forEach(function(st){ if(document.body.contains(st.el)) build(st); }); }
  window.addEventListener('resize',function(){ clearTimeout(timer); timer=setTimeout(function(){
    strips.forEach(function(st){ var on=!calm.matches; if(on!==st.el.classList.contains('gs-mq-on')||wide.matches!==st.wide||(on&&st.el.clientWidth>st.w)) build(st); });
  },200); });
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ setup(); }); else setup();
  window.addEventListener('load',rebuild);
  document.addEventListener('shopify:section:load',function(e){ setup(e.target); });
})();


/* PLANS (only in the -animated file). Section 13, the three plans, on phones.
   A row marked data-anim="plans" holds the plans (data-plan). The script adds gs-plans-on to the row, which switches the phone layout to the picker (CSS, phones only),
   and gs-sel to the chosen plan, which opens it. It starts on the plan marked data-plan-default (the first one if none is marked).
   A tap on a closed plan opens it and closes the one that was open; a tap inside the open plan does nothing special, so its button works as always.
   When the plan above closes, the page gets shorter; if that would leave the top of the newly opened plan above the screen, the page is scrolled so it is in view.
   On phones the plans also get role, tabindex and aria-expanded so they work from a keyboard (Enter or Space).
   On desktop the classes have no effect: the three cards stand side by side. Without this script phones show the three full cards.
   It stands alone and runs again when Shopify's theme editor reloads a section. */
(function(){
  if(!window.matchMedia) return;
  var wide=window.matchMedia('(min-width:861px)');
  function setup(root){
    var found=(root&&root.querySelectorAll?root:document).querySelectorAll('[data-anim="plans"]');
    Array.prototype.forEach.call(found,function(box){
      if(box.getAttribute('data-gs-ready')) return;
      var plans=box.querySelectorAll('[data-plan]');
      if(plans.length<2) return;
      box.setAttribute('data-gs-ready','1');
      var phone=!wide.matches;
      function syncAccess(){ phone=!wide.matches; Array.prototype.forEach.call(plans,function(p){ if(phone){p.setAttribute('role','button');p.setAttribute('tabindex','0');p.setAttribute('aria-expanded',p.classList.contains('gs-sel')?'true':'false');}else{p.removeAttribute('role');p.removeAttribute('tabindex');p.removeAttribute('aria-expanded');} }); }
      wide.addEventListener('change',syncAccess);
      function pick(p,show){
        Array.prototype.forEach.call(plans,function(q){
          var on=q===p; q.classList.toggle('gs-sel',on);
          if(phone) q.setAttribute('aria-expanded',on?'true':'false');
        });
        if(show&&!wide.matches){ var r=p.getBoundingClientRect(), h=document.querySelector('.page-header'), offset=(h?h.getBoundingClientRect().height:0)+16; if(r.top<offset) window.scrollBy(0,r.top-offset); }
      }
      var first=plans[0];
      Array.prototype.forEach.call(plans,function(p){
        if(p.hasAttribute('data-plan-default')) first=p;
        if(phone){ p.setAttribute('role','button'); p.setAttribute('tabindex','0'); }
        p.addEventListener('click',function(e){
          if(wide.matches||p.classList.contains('gs-sel')) return;
          e.preventDefault(); pick(p,true);
        });
        p.addEventListener('keydown',function(e){
          if(wide.matches||p.classList.contains('gs-sel')||e.target!==p) return;
          if(e.key==='Enter'||e.key===' '){ e.preventDefault(); pick(p,true); }
        });
      });
      box.classList.add('gs-plans-on');
      pick(first,false); syncAccess();
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ setup(); }); else setup();
  document.addEventListener('shopify:section:load',function(e){ setup(e.target); });
})();


/* COMPARE (only in the -animated file). Section 11, the comparison table, on phones.
   A wrapper marked data-anim="compare" holds buttons (data-cmp-btn="3", "4", "5": the table column each one shows) and the table (data-cmp-table).
   The script adds gs-cmp-on to the wrapper, which switches the phone layout to the picker (CSS, phones only), marks the chosen button (gs-cmp-cur, aria-pressed)
   and puts gs-cmp-3, gs-cmp-4 or gs-cmp-5 on the table, which decides the column shown next to Growth Serum. It starts on the button that has aria-pressed="true" in the page.
   On desktop the classes have no effect: the buttons are hidden and the whole table shows. Without this script phones show the earlier breakdown of every row.
   It stands alone and runs again when Shopify's theme editor reloads a section. */
(function(){
  function setup(root){
    var found=(root&&root.querySelectorAll?root:document).querySelectorAll('[data-anim="compare"]');
    Array.prototype.forEach.call(found,function(box){
      if(box.getAttribute('data-gs-ready')) return;
      var table=box.querySelector('[data-cmp-table]'), btns=box.querySelectorAll('[data-cmp-btn]');
      if(!table||!btns.length) return;
      box.setAttribute('data-gs-ready','1');
      function pick(col){
        Array.prototype.forEach.call(btns,function(b){
          var c=b.getAttribute('data-cmp-btn'), on=c===col;
          b.classList.toggle('gs-cmp-cur',on); b.setAttribute('aria-pressed',on?'true':'false');
          table.classList.toggle('gs-cmp-'+c,on);
        });
      }
      var first=btns[0].getAttribute('data-cmp-btn');
      Array.prototype.forEach.call(btns,function(b){
        if(b.getAttribute('aria-pressed')==='true') first=b.getAttribute('data-cmp-btn');
        b.addEventListener('click',function(){ pick(b.getAttribute('data-cmp-btn')); });
      });
      box.classList.add('gs-cmp-on');
      pick(first);
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ setup(); }); else setup();
  document.addEventListener('shopify:section:load',function(e){ setup(e.target); });
})();


/* TAP SHAKE (only in the -animated file). Section 10, the review cards, and section 14, the gift cards, on phones.
   A tap on an element marked data-tap-shake gives it gs-tap, which plays a short shake (CSS, phones only); the class is taken off again when the shake ends,
   so the next tap shakes it again. A card that is still being shaken in (it has gs-armed but not yet gs-done) ignores the tap.
   On desktop the class has no effect: there the cards shake under the cursor. Without this script a tap simply does nothing.
   It stands alone and runs again when Shopify's theme editor reloads a section. */
(function(){
  function setup(root){
    var found=(root&&root.querySelectorAll?root:document).querySelectorAll('[data-tap-shake]');
    Array.prototype.forEach.call(found,function(el){
      if(el.getAttribute('data-tap-ready')) return;
      el.setAttribute('data-tap-ready','1');
      el.addEventListener('click',function(){
        if(el.classList.contains('gs-armed')&&!el.classList.contains('gs-done')) return;
        el.classList.remove('gs-tap'); void el.offsetWidth; el.classList.add('gs-tap');
      });
      el.addEventListener('animationend',function(e){ if(e.target===el) el.classList.remove('gs-tap'); });
      el.addEventListener('animationcancel',function(e){ if(e.target===el) el.classList.remove('gs-tap'); });
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ setup(); }); else setup();
  document.addEventListener('shopify:section:load',function(e){ setup(e.target); });
})();


/* ARROW (only in the -animated file). Draws a curved arrow from the end of one piece of text to another.
   Mark the start with data-arrow-from="name" and the target with data-arrow-to="name" (same name on both).
   The arrow leaves the end of the start text, swings out to the right and comes in to the right-hand side of the target, pointing at it.
   It is measured from where the two texts really are and redrawn when the window changes size, so it keeps working after a change of wording or language.
   It draws itself in the first time the target has scrolled up to about the middle of the screen, not as soon as it appears,
   so it does not pull the reader away from the section above. Desktop and phones; on phones the swing to the right is smaller, so the arrow stays on the screen.
   Without this script there is just no arrow.
   It stands alone and runs again when Shopify's theme editor reloads a section. */
(function(){
  if(!window.matchMedia||!document.createElementNS) return;
  var NS='http://www.w3.org/2000/svg', wide=window.matchMedia('(min-width:861px)'), arrows=[], timer=null, EDGE=12;
  function draw(a){
    if(!document.body.contains(a.from)||!document.body.contains(a.to)) return;
    var host=a.host, hb=host.getBoundingClientRect();
    var fr=a.from.getClientRects(), f=fr[fr.length-1], t=a.to.getBoundingClientRect();
    if(!f||!t.width) return;
    var sx=f.right+12-hb.left, sy=f.top+f.height*0.6-hb.top, ex=t.right+14-hb.left, ey=t.top+t.height*0.55-hb.top;
    var dy=ey-sy, out=Math.max(50,Math.min(110,Math.abs(dy)*0.45));
    /* phones: there is little room beside the text, so the swing to the right is held inside the screen (EDGE px from its right edge) */
    if(!wide.matches) out=Math.max(16,Math.min(out,hb.width-EDGE-Math.max(sx,ex)));
    var c1x=sx+out, c1y=sy+dy*0.25, c2x=Math.max(sx,ex)+out, c2y=ey-dy*0.2;
    var ux=ex-c2x, uy=ey-c2y, ul=Math.sqrt(ux*ux+uy*uy)||1; ux/=ul; uy/=ul;
    function wing(deg){ var r=deg*Math.PI/180, x=ux*Math.cos(r)-uy*Math.sin(r), y=ux*Math.sin(r)+uy*Math.cos(r); return (ex-x*12).toFixed(1)+' '+(ey-y*12).toFixed(1); }
    if(!a.svg){
      a.svg=document.createElementNS(NS,'svg'); a.svg.setAttribute('class','gs-arrow'); a.svg.setAttribute('aria-hidden','true');
      a.line=document.createElementNS(NS,'path'); a.line.setAttribute('class','gs-arrowLine');
      a.head=document.createElementNS(NS,'path'); a.head.setAttribute('class','gs-arrowHead');
      a.svg.appendChild(a.line); a.svg.appendChild(a.head);
    }
    if(a.svg.parentNode!==host) host.appendChild(a.svg);
    a.line.setAttribute('d','M'+sx.toFixed(1)+' '+sy.toFixed(1)+' C'+c1x.toFixed(1)+' '+c1y.toFixed(1)+' '+c2x.toFixed(1)+' '+c2y.toFixed(1)+' '+ex.toFixed(1)+' '+ey.toFixed(1));
    a.head.setAttribute('d','M'+wing(28)+' L'+ex.toFixed(1)+' '+ey.toFixed(1)+' L'+wing(-28));
    try{ a.svg.style.setProperty('--len',Math.ceil(a.line.getTotalLength())+1); }catch(e){}
  }
  function setup(root){
    var froms=(root&&root.querySelectorAll?root:document).querySelectorAll('[data-arrow-from]');
    Array.prototype.forEach.call(document.querySelectorAll('[data-arrow-from]'),function(from){
      if(from.getAttribute('data-gs-ready')) return;
      var name=from.getAttribute('data-arrow-from'), to=document.querySelector('[data-arrow-to="'+name+'"]');
      if(!to) return;
      var host=to.closest?to.closest('section'):null; host=host||to.parentNode;
      from.setAttribute('data-gs-ready','1'); host.classList.add('gs-arrowHost');
      var a={from:from,to:to,host:host,svg:null}; arrows.push(a); draw(a);
      if('IntersectionObserver' in window){
        /* wait until the target has come up to the middle of the screen (the bottom 45% does not count), so the arrow only appears once the reader has clearly moved on to the next section */
        var io=new IntersectionObserver(function(es){ es.forEach(function(e){ if(e.isIntersecting&&a.svg){ a.svg.classList.add('gs-draw'); io.disconnect(); } }); },{threshold:1,rootMargin:'0px 0px -45% 0px'});
        io.observe(to);
      } else if(a.svg) a.svg.classList.add('gs-draw');
    });
  }
  function redraw(){ arrows.forEach(draw); }
  window.addEventListener('resize',function(){ clearTimeout(timer); timer=setTimeout(redraw,150); });
  window.addEventListener('load',redraw);
  if(document.fonts&&document.fonts.ready&&document.fonts.ready.then) document.fonts.ready.then(redraw);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ setup(); }); else setup();
  document.addEventListener('shopify:section:load',function(){ setup(); redraw(); });
})();


/* TEASER (only in the -animated file). Section 4, the "What this means for you?" box, on phones (also sections 9 and 11, and the two folds in the guarantee, section 16).
   A box marked data-anim="teaser" shows only the first lines of its text (data-teaser-body) on screens 860px and narrower.
   A tap on the box or on its button (data-teaser-btn) opens the rest; the button closes it again.
   The script only switches classes (gs-more-on, gs-open, gs-open-done) and tells the CSS how tall the full text is (--gs-more-h), so the slide ends exactly at the text's own height.
   On wider screens it does nothing: the box is open, as it always was. Without this script the box is open on phones too.
   It stands alone and runs again when Shopify's theme editor reloads a section. */
(function(){
  if(!window.matchMedia) return;
  var wide=window.matchMedia('(min-width:861px)'), calm=window.matchMedia('(prefers-reduced-motion: reduce)');
  function setup(root){
    var found=(root&&root.querySelectorAll?root:document).querySelectorAll('[data-anim="teaser"]');
    Array.prototype.forEach.call(found,function(box){
      if(box.getAttribute('data-gs-ready')) return;
      var body=box.querySelector('[data-teaser-body]'), btn=box.querySelector('[data-teaser-btn]');
      if(!body||!btn) return;
      box.setAttribute('data-gs-ready','1'); box.classList.add('gs-more-on');
      function set(open){
        if(wide.matches) return;
        box.style.setProperty('--gs-more-h',body.scrollHeight+'px');
        box.classList.remove('gs-open-done');
        void body.offsetHeight;
        box.classList.toggle('gs-open',open);
        btn.setAttribute('aria-expanded',open?'true':'false');
        if(open&&calm.matches) box.classList.add('gs-open-done');
      }
      /* once it has slid open the height limit is taken off, so the text can never be cut if the screen is turned */
      body.addEventListener('transitionend',function(e){ if(e.target===body&&e.propertyName==='max-height'&&box.classList.contains('gs-open')) box.classList.add('gs-open-done'); });
      btn.addEventListener('click',function(e){ e.stopPropagation(); set(!box.classList.contains('gs-open')); });
      box.addEventListener('click',function(){ if(!box.classList.contains('gs-open')) set(true); });
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ setup(); }); else setup();
  document.addEventListener('shopify:section:load',function(e){ setup(e.target); });
})();


/* STAGES (only in the -animated file). Section 8, the three microcamera photos, on screens 860px and narrower.
   A row marked data-anim="stages" holds cards marked data-stage; each card has a photo and a name (data-stage-tab).
   On a phone the row becomes one large photo that moves through the stages (the layout and the fade are CSS, see "8 the study photos ON PHONES").
   The script switches classes: gs-st-on on the row (the large-photo layout), gs-st-in on every card up to the current one (photo shown),
   gs-st-cur on the current card (its name is highlighted), gs-st-run on the row while it moves on by itself, gs-st-held once the visitor has tapped.
   It also tells the CSS how long the current photo stays (--gs-st-ms, read from data-stage-ms on the card; 2400 if missing)
   and makes the names work as buttons (role, tabindex, aria-pressed; Enter and Space work too).
   It starts when the frame is where she is reading: its top edge 58% down the screen or higher, and the whole frame above the sticky button bar
   (the same "watch" line as elsewhere, see Knowledge/viewport_gaze_hot_zones_by_device.svg). It pauses while the frame is off screen.
   LOOP below: true = after the last photo it starts again from the first; false = it stops on the last photo.
   A tap on a name shows that photo; a tap on the photo shows the next one. Either stops the automatic run for good.
   Not on wider screens and not for visitors with reduced motion. Without this script the three photos stand side by side.
   It stands alone and runs again when Shopify's theme editor reloads a section. */
(function(){
  if(!window.matchMedia) return;
  var LOOP=false, WATCH=0.82, wide=window.matchMedia('(min-width:861px)'), calm=window.matchMedia('(prefers-reduced-motion: reduce)');
  function setup(root){
    var found=(root&&root.querySelectorAll?root:document).querySelectorAll('[data-anim="stages"]');
    Array.prototype.forEach.call(found,function(row){
      if(row.getAttribute('data-gs-ready')) return;
      var cards=row.querySelectorAll('[data-stage]'), n=cards.length;
      if(n<2) return;
      row.setAttribute('data-gs-ready','1');
      var cur=0, timer=null, held=false, started=false, inView=true;
      function show(i){
        cur=i;
        Array.prototype.forEach.call(cards,function(c,k){
          c.classList.toggle('gs-st-in',k<=i); c.classList.toggle('gs-st-cur',k===i);
          var t=c.querySelector('[data-stage-tab]'); if(t) t.setAttribute('aria-pressed',k===i?'true':'false');
        });
      }
      function stay(){ var ms=parseInt(cards[cur].getAttribute('data-stage-ms'),10); return ms>0?ms:2400; }
      function stop(){ clearTimeout(timer); timer=null; row.classList.remove('gs-st-run'); }
      function run(){
        stop();
        if(held||!started||!inView||wide.matches||calm.matches) return;
        if(!LOOP&&cur===n-1) return;
        row.style.setProperty('--gs-st-ms',stay()+'ms');
        void row.offsetWidth;
        row.classList.add('gs-st-run');
        timer=setTimeout(function(){ show((cur+1)%n); run(); },stay());
      }
      function pick(i){ held=true; stop(); row.classList.add('gs-st-held'); show(i); }
      Array.prototype.forEach.call(cards,function(c,k){
        var t=c.querySelector('[data-stage-tab]'), ph=c.querySelector('.ph');
        if(t){
          t.setAttribute('role','button'); t.setAttribute('tabindex','0');
          t.addEventListener('click',function(){ pick(k); });
          t.addEventListener('keydown',function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); pick(k); } });
        }
        if(ph) ph.addEventListener('click',function(){ pick((cur+1)%n); });
      });
      function syncMode(){ var active=!wide.matches&&!calm.matches; row.classList.toggle('gs-st-on',active); Array.prototype.forEach.call(cards,function(c){var t=c.querySelector('[data-stage-tab]'); if(t){if(active){t.setAttribute('role','button');t.setAttribute('tabindex','0');}else{t.removeAttribute('role');t.removeAttribute('tabindex');}}}); run(); }
      wide.addEventListener('change',syncMode); calm.addEventListener('change',syncMode);
      show(0); syncMode();
      if(!('IntersectionObserver' in window)){ started=true; run(); return; }
      var first;
      function watch(){
        if(first) first.disconnect();
        if(started||!row.isConnected) return;
        var vh=window.innerHeight||0, h=document.querySelector('.page-header'), top=h?h.getBoundingClientRect().height:0;
        first=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){started=true;first.disconnect();run();}});},{threshold:0,rootMargin:'-'+Math.round(top)+'px 0px -'+Math.round(vh*(1-WATCH))+'px 0px'});
        first.observe(row);
      }
      watch(); window.addEventListener('resize',watch,{passive:true}); document.addEventListener('sfg:geometry',watch);
      new IntersectionObserver(function(es){
        es.forEach(function(e){ inView=e.isIntersecting; if(inView) run(); else stop(); });
      },{threshold:0}).observe(row);
    });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ setup(); }); else setup();
  document.addEventListener('shopify:section:load',function(e){ setup(e.target); });
})();


/* CYCLE ON PHONES (only in the -animated file). Section 4, how hair grows, on screens 860px and narrower.
   The small gold arrows between the three cards, the two curved arrows under card 3 and the handwritten note between them follow the scroll, in both directions.
   Two lines across the screen decide how far a piece is drawn: it starts when its top edge comes up past the lower line and is complete
   when it reaches the upper line (START and END below, as a share of the screen height: 0.5 is the middle of the screen).
   Both lines sit at the lower edge of the zone the eye rests in on a phone (25% to 50% of the screen height, see Knowledge/viewport_gaze_hot_zones_by_device.svg).
   So the arrow out of a card sets off when the bottom edge of that card passes the middle of the screen, and is complete a little above it
   (the distance between the two lines is how much scrolling a piece takes: 5% of the screen height, about 45px on a phone).
   The script switches the pieces on (gs-cy-on), tells each line how far it is drawn (--gs-p, 0 to 1), marks a card whose arrow has arrived (gs-hit,
   which makes its number badge pulse) and the note whose arrow has arrived (gs-on, which makes the words pop in). Scrolling back takes all of it back.
   Not on wider screens and not for visitors with reduced motion. Without this script the three cards are simply there, with no arrows and no note.
   It stands alone and runs again when Shopify's theme editor reloads a section. */
(function(){
  if(!window.requestAnimationFrame||!window.matchMedia) return;
  var wide=window.matchMedia('(min-width:861px)'), calm=window.matchMedia('(prefers-reduced-motion: reduce)');
  var START=0.5, END=0.45;
  var rows=[], queued=false;
  function setup(root){
    var found=(root&&root.querySelectorAll?root:document).querySelectorAll('[data-anim="cycle"]');
    Array.prototype.forEach.call(found,function(el){
      if(el.getAttribute('data-cy-ready')) return;
      var cards=el.querySelectorAll('[data-cy-step]'); if(!cards.length) return;
      el.setAttribute('data-cy-ready','1');
      var host=el.closest?el.closest('section'):null, note=(host||document).querySelector('[data-cy-note]');
      rows.push({el:el,cards:cards,note:note,noteB:note?note.querySelector('[data-cy-note-b]'):null});
    });
    ask();
  }
  function share(y,a,b){ return Math.max(0,Math.min(1,(a-y)/(a-b))); }
  function mark(el,on,off){ if(on) el.classList.add('gs-hit'); else if(off) el.classList.remove('gs-hit'); }
  function update(){
    queued=false;
    var on=!wide.matches&&!calm.matches, vh=window.innerHeight, a=vh*START, b=vh*END;
    rows.forEach(function(r){
      if(!document.body.contains(r.el)) return;
      r.el.classList.toggle('gs-cy-on',on); if(r.note) r.note.classList.toggle('gs-cy-on',on);
      if(!on) return;
      var box=r.el.getBoundingClientRect();
      if(box.bottom<-500||box.top>vh+500) return;
      var i, n=r.cards.length, prev=null, cr, p, link;
      for(i=0;i<n;i++){
        cr=r.cards[i].getBoundingClientRect();
        if(i===0){ mark(r.cards[i],cr.top<a,cr.top>a+80); }
        else{
          p=share(prev.bottom,a,b);
          link=r.cards[i].querySelector('[data-cy-link]'); if(link) link.style.setProperty('--gs-p',p.toFixed(3));
          mark(r.cards[i],p>=1,p<0.5);
        }
        prev=cr;
      }
      if(r.note){
        p=share(prev.bottom,a,b);
        r.note.style.setProperty('--gs-p',p.toFixed(3));
        r.note.classList.toggle('gs-on',p>=1);
        /* the arrow back up only sets off once the words are there, and takes as much scrolling again as the arrow in */
        if(r.noteB) r.noteB.style.setProperty('--gs-p',Math.max(0,Math.min(1,(a-prev.bottom)/(a-b)-1.15)).toFixed(3));
      }
    });
  }
  function ask(){ if(!queued){ queued=true; requestAnimationFrame(update); } }
  window.addEventListener('scroll',ask,{passive:true});
  window.addEventListener('resize',ask);
  window.addEventListener('load',ask);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ setup(); }); else setup();
  document.addEventListener('shopify:section:load',function(e){ setup(e.target); });
})();

}
